import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import RasterHeatmap from 'components/features/RasterHeatmap/RasterHeatmap';

class HeatmapPage extends Component {
  render() {
    let id = this.props.match.params.id;
    return (
      <div className={'HeatmapPage_TopDiv'}>
        <RasterHeatmap id={id} />
      </div>
    );
  }
}

/* Using withRouter gives connected components access to react-router match*/
export default withRouter(
  connect((store) => {
    return {};
  })(HeatmapPage)
);
